/* global $ */

// Accordions
$.$body
  .on('focus', '.module__accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', true);
  })
  .on('blur', '.module__accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', false);
  })
  .on('click', '.module__accordion .js-accordion-button', (e) => {
    e.preventDefault();
    console.log('accordion open');

    const $button = $(e.currentTarget);
    const isExpanded = $button.attr('aria-expanded') === 'true';
    const $header = $button.closest('.accordion__headline');
    const $section = $header.next('.accordion__content');

    $button.attr('aria-expanded', !isExpanded);
    $section.attr('aria-hidden', isExpanded);

    if (!isExpanded) {
      // const $rowAnchor = $header.closest('.accordion__single-row');
      // window.scrollTo(0, $rowAnchor.offset().top - 95);
      // if (false && 'scrollIntoViewIfNeeded' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoViewIfNeeded(false);
      // } else if (false && 'scrollIntoView' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoView(true);
      // } else {
      //   window.scrollTo(0, $rowAnchor.offset().top - 95);
      // }
    }
  });
